import type { NextPage } from 'next/types';
import type { ReactElement, ReactNode } from 'react';

import type { ContentfulFixedPageCMSData } from '@/integrations/contentful';
import { useCmsDataWithSaleorProductSkus } from '@/lib/productSkus';

export type FixedPageProps = {
  cms?: ContentfulFixedPageCMSData;
};

export const withFixedPageCommonProps = <P extends FixedPageProps>(
  WrappedComponent: NextPage<P> & {
    getLayout?: (page: ReactElement) => ReactNode;
  },
) => {
  const EnhancedComponent: NextPage<P> & {
    getLayout?: (page: ReactElement) => ReactNode;
  } = (props: P) => {
    const [topContentWithProductInfo, bottomContentWithProductInfo] =
      useCmsDataWithSaleorProductSkus(
        props.cms?.saleorProductSkus,
        props.cms?.saleorProductSkusProductVariant,
        props.cms?.topContent ?? [],
        props.cms?.bottomContent ?? [],
      );
    const newProps = {
      ...props,
      cms: {
        ...props.cms,
        topContent: topContentWithProductInfo,
        bottomContent: bottomContentWithProductInfo,
      },
    };

    return <WrappedComponent {...newProps} />;
  };

  if (WrappedComponent.getLayout) {
    EnhancedComponent.getLayout = WrappedComponent.getLayout;
  }

  return EnhancedComponent;
};
